import { message, Select, Spin } from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth } from "utils/api";
import { Wrapper } from "./businessSnapshotCard.styled";
import { asVolume } from "utils/text";

export default function BusinessSnapshotCard() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [viewMode, setViewMode] = useState("current");
  const [statData, setStatData] = useState({
    mp: 0,
    cp: 0,
    ap: 0,
    op: 0,
    qop: 0,
    eop: 0,
    acc: 0,
    c_cnt: 0,
    tl_cnt: 0,
    stl_cnt: 0,
    op3: 0,
    op8: 0,
    c_mp: 0
  });

  const onGetStatData = (res) => {
    setIsLoaded(true);
    if (!res.success) {
      return message.error(res.message);
    }
    setStatData(res.data);
  };
  const onFailStatData = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    setIsLoaded(false);
    if (viewMode == "current") {
      callGetApiWithAuth(
        "dashboard/business_snapshot/stats",
        onGetStatData,
        onFailStatData
      );
    } else if (viewMode == "last") {
      callGetApiWithAuth(
        "dashboard/business_snapshot/last_stats",
        onGetStatData,
        onFailStatData
      );
    }
  }, [viewMode]);

  return (
    <Wrapper className="white-rounded-bg">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="card-title">Business Snapshot</div>
        <Select
          value={viewMode}
          onChange={(v) => setViewMode(v)}
          options={[
            {
              label: "Current Month",
              value: "current",
            },
            {
              label: "Last Month",
              value: "last",
            },
          ]}
          style={{ width: "160px" }}
        />
      </div>

      {isLoaded ? (
        <div className="snapshot-details flex-fill">
          {[
            { label: "Marketer Points (on Subscriptions)", value: asVolume(statData.mp) },
            { label: "Customer Points", value: asVolume(statData.cp) },
            { label: "Activity Points", value: asVolume(statData.ap) },
            { label: "Organization Points", value: asVolume(statData.op) },
            { label: "Enroller Organization Points", value: asVolume(statData.eop) },
            { label: "Active Customer Count", value: statData.acc },
            { label: "Enrolled Consultant Legs", value: statData.c_cnt },
            { label: "Team Leader Legs", value: statData.tl_cnt },
            { label: "Senior Team Leader Legs", value: statData.stl_cnt },
            // { label: "OP3", value: asVolume(statData.pv3) },
            // { label: "OP8", value: asVolume(statData.pv8) },
            // { label: "CV3", value: asVolume(statData.op3) },
            // { label: "CV8", value: asVolume(statData.op8) },
          ].map((item, index) => (
            <div className="snapshot-row" key={index}>
              <span className="label">{item.label}</span>
              <span className="value">{item.value ?? 0}</span>
            </div>
          ))}

          <div className="snapshot-row">
            <span className="label">Commission Qualified</span>
            <span className="value">
              {statData.c_mp >= 40 || statData.ap >= 80 || (statData.cp >= 300 && statData.acc >= 3) ? (
                <>
                  <span style={{ color: "green" }}>✅</span> Yes
                </>
              ) : (
                <>
                  <span style={{ color: "red" }}>❌</span>No
                </>
              )}
            </span>
          </div>
        </div>
      ) : (
        <div style={{ height: 300 }}>
          <Spin spinning={true} className="loading-icon" />
        </div>
      )}
    </Wrapper>
  );
}
